<template>
  <div id="login">
    <!--<div class="themeList">
      <div class="tl_title">测试主题</div>
      <el-select v-model="theme" @change="changeTheme">
        <el-option v-if="theme != '默认'" value="默认">默认</el-option>
        <el-option v-if="theme != '星空'" value="星空">星空</el-option>
      </el-select>
    </div>-->
    <div class="form theme-2">
      <h1 class="title2">友途CRM管理系统</h1>
      <div class="f_line">
        <div class="fl_label">
          <i class="fa fa-user"></i>
        </div>
        <div class="fl_inputBox">
          <input type="text" placeholder="用户名" v-model="userName">
        </div>
      </div>
      <div class="f_line">
        <div class="fl_label">
          <i class="fa fa-lock"></i>
        </div>
        <div class="fl_inputBox">
          <input type="password" placeholder="密码" v-model="passWord" @keyup.enter="submitLogin">
        </div>
      </div>
      <!-- <div class="f_line fl_RandCode">
        <div class="fl_label">
          <i class="fa fa-ticket"></i>
        </div>
        <div class="fl_inputBox">
          <input type="text" placeholder="验证码" v-model="loginRandCode" maxlength="5" @keyup.enter="submitLogin">
          <img :src="randCodeSrc" @click="changeRandCode()">
        </div>
      </div> -->
      <button class="f_submitBtn" @click="submitLogin">登&nbsp;&nbsp;录</button>
    </div>
    <canvas id="starts">该浏览器不支持canvas</canvas>
  </div>
</template>

<script src="http://libs.baidu.com/jquery/1.11.0/jquery.js"></script>
<script>
import {baseUrl, devCode} from '@/http/baseUrl.js';

export default {
  name: 'login',
  data () {
    return {
      userName: '',
      passWord: '',
      loginRandCode: '',
      randCodeSrc: baseUrl + '/admin/loginImage?t=' + new Date().getTime()
    };
  },
  created () {
    if (localStorage.getItem('loginTheme')) {
      this.theme = localStorage.getItem('loginTheme');
    }
    this.$nextTick(() => {
      this.canvas('starts', 200, 1000, 60, 2, 400000, 0.5);
    })
  },
  methods: {
    submitLogin () {
      if (this.userName === '') {
        return this.$message.error('请输入账号');
      }
      if (this.passWord === '') {
        return this.$message.error('请输入密码');
      }
      /*if (this.loginRandCode === '') {
        return this.$message.error('请输入验证码');
      }*/
      this.axios({
        method: 'post',
        url: '/admin/internal/user/login',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        },
        data: {
          // type: 0,
          username: this.userName,
          password: this.passWord,
          source: 'internal'
          // loginRandCode: this.loginRandCode
        },
        withCredentials: true
      }).then(res => {
        console.log(res)
        if (res.data.errorCode === 0) {
          // this.$store.commit('setManagerId', res.data.data);
          sessionStorage.setItem('ifAuditor', res.data.data.auditor);
          sessionStorage.setItem('name', res.data.data.name);
          sessionStorage.setItem('username', res.data.data.username);
          sessionStorage.setItem('bs', res.data.data.token);
          this.$router.replace({name: 'appIndex', params: {data: res.data.data}});
        } else {
          this.changeRandCode();
          this.$message.warning(res.data.errorMsg);
        }
      });
    },
    changeRandCode () {
      this.randCodeSrc = baseUrl + '/admin/loginImage?callback=youtu&t=' + new Date().getTime();
    },
    // 更改主题
    changeTheme () {
      localStorage.setItem('loginTheme', this.theme)
      this.$nextTick(() => {
        this.canvas('starts', 200, 1000, 60, 2, 400000, 0.5);
      })
    },
    // canvas特效
    canvas (id, starscolor, starsamount, starsradius, movrange, speed, trailing) {
      // 宇宙特效
      var canvas = document.getElementById(id),
        ctx = canvas.getContext('2d'),
        w = canvas.width = window.innerWidth,
        h = canvas.height = window.innerHeight,

        hue = starscolor, // 230
        stars = [],
        count = 0,
        maxStars = starsamount; // 星星数量

      var canvas2 = document.createElement('canvas'),
        ctx2 = canvas2.getContext('2d');
      canvas2.width = 100;
      canvas2.height = 100;
      var half = canvas2.width / 2,
        gradient2 = ctx2.createRadialGradient(half, half, 0, half, half, half);
//      gradient2.addColorStop(0.025, '#ccc');
//      gradient2.addColorStop(0.1, 'hsl(' + hue + ', 61%, 33%)');
//      gradient2.addColorStop(0.25, 'hsl(' + hue + ', 64%, 6%)');
      gradient2.addColorStop(0.02, '#ccc');
      gradient2.addColorStop(0.05, 'hsl(' + hue + ', 64%, 6%)');
      gradient2.addColorStop(0.9, 'transparent');
      gradient2.addColorStop(0.1, 'transparent');

      ctx2.fillStyle = gradient2;
      ctx2.beginPath();
      ctx2.arc(half, half, half, 0, Math.PI * 2);
      ctx2.fill();

      // End cache

      function random (min, max) {
        if (arguments.length < 2) {
          max = min;
          min = 0;
        }

        if (min > max) {
          var hold = max;
          max = min;
          min = hold;
        }

        return Math.floor(Math.random() * (max - min + 1)) + min;
      }

      function maxOrbit (x, y) {
        var max = Math.max(x, y),
          diameter = Math.round(Math.sqrt(max * max + max * max));
        return diameter / movrange;
        // 星星移动范围，值越大范围越小，
      }

      var Star = function () {

        this.orbitRadius = random(maxOrbit(w, h));
        this.radius = random(starsradius, this.orbitRadius) / 8;
        // 星星半径大小
        this.orbitX = w / 2;
        this.orbitY = h / 2;
        this.timePassed = random(0, maxStars);
        this.speed = random(this.orbitRadius) / speed;
        // 星星移动速度
        this.alpha = random(2, 10) / 10;

        count++;
        stars[count] = this;
      }

      Star.prototype.draw = function () {
        var x = Math.sin(this.timePassed) * this.orbitRadius + this.orbitX,
          y = Math.cos(this.timePassed) * this.orbitRadius + this.orbitY,
          twinkle = random(10);

        if (twinkle === 1 && this.alpha > 0) {
          this.alpha -= 0.05;
        } else if (twinkle === 2 && this.alpha < 1) {
          this.alpha += 0.05;
        }

        ctx.globalAlpha = this.alpha;
        ctx.drawImage(canvas2, x - this.radius / 2, y - this.radius / 2, this.radius, this.radius);
        this.timePassed += this.speed;
      }

      for (var i = 0; i < maxStars; i++) {
        new Star();
      }

      function animation () {
        ctx.globalCompositeOperation = 'source-over';
        ctx.globalAlpha = trailing; // 尾巴
        ctx.fillStyle = 'hsla(' + hue + ', 64%, 6%, 2)';
        ctx.fillRect(0, 0, w, h)

        ctx.globalCompositeOperation = 'lighter';
        for (var i = 1, l = stars.length; i < l; i++) {
          stars[i].draw();
        };

        window.requestAnimationFrame(animation);
      }

      animation();
    }
  }
};
</script>

<style lang="scss" scoped>
$lineHeight: 40px;
$dsgColor: #fafafa;
#login {position: relative; width: 100%; height: 100%; overflow: hidden; color: #fff;}
.bgColor {
  position: absolute; bottom: 0; width: 100%; height: 130%; transform: rotate(180deg);
  background: radial-gradient(ellipse at center, rgba(110, 165, 142, 1) 0%, rgba(95, 142, 131, 1) 36%, rgba(19, 58, 117, 1) 100%);
}
.bgImg {position: absolute; bottom: 0; width: 100%; height: 100%;}
.title {position: absolute; top: -80px; left: 0px; z-index: 2; font-size: 24px; text-align: center;
  font-weight: 100; text-shadow: 1px 1px 3px rgba(0, 0, 0, .6);}
.title2 {position: absolute; top: -40px; left: 0; z-index: 2; width: 100%; font-size: 34px;
  text-align: center; font-weight: 100; text-shadow: 1px 1px 3px rgba(0, 0, 0, .6);}

.form {position: absolute; top: 50%; left: 50%; z-index: 2; width: 400px; height: 300px;
  padding: 45px 50px 0; margin: -150px 0 0 -200px; font-size: 16px;
  border-radius: 2px; background-color: rgba(255, 255, 255, .2);
  &.theme-2{background-color: transparent;}
}
.f_line {
  height: $lineHeight; line-height: $lineHeight; margin-bottom: 20px; border-radius: 2px;
  border: 1px solid rgba(255, 255, 255, .4); background-color: rgba(0,0,0,.3);
  /*box-shadow: 1px 1px 4px rgba(0,0,0,.2) inset;*/
}
.fl_label {float: left; width: 40px; text-align: center; font-size: 18px; color: $dsgColor;}
.fl_inputBox {
  float: right; width: 240px;
  input {
    outline: none; background-color: transparent; border: none; color: #fff; font-size: 14px;
    &::-webkit-input-placeholder {color: $dsgColor;}
  }
}

.fl_RandCode {
  .fl_inputBox {
    float: left; margin-left: 20px; width: 220px; line-height: 38px; white-space: nowrap;
    input {width: 114px;}
    img {height: 38px; vertical-align: bottom;}
  }
}

.f_submitBtn {
  width: 300px; height: $lineHeight; border: none; border-radius: 2px;
  background-color: rgba(238, 238, 238, .9);
  font-size: 16px; color: #666; font-weight: bold; cursor: pointer;
  &:hover {background-color: #fefefe;}
}

.themeList{
  position: absolute; right: 30px; top: 20px; z-index: 5;
  .tl_title{display: inline-block; margin-right: 5px;}
  .el-select{width: 80px;}
  .el-input--suffix .el-input__inner{background-color: transparent;}
}
</style>



// WEBPACK FOOTER //
// src/components/login/index.vue